import { useEffect, useRef, useState } from "react";
import { findSubNode, getCustomisationValue, getGroupData } from "../../EditablePreview";
import './LBList.scss';
import VisualisedNode from "../VisualisedNode";
import PlayerImagePlaceholder from "./playerImagePlaceholder.png";

const DUMMY_LEADERBOARD_DATA = [
    { rank: 1, name: "PlayerOne", score: 1500, time: 125000 },
    { rank: 2, name: "PlayerTwo", score: 1400, time: 130000 },
    { rank: 3, name: "PlayerThree", score: 1300, time: 135000 },
    { rank: 4, name: "PlayerFour", score: 1200, time: 140000 },
    { rank: 5, name: "PlayerFive", score: 1100, time: 145000 },
];

const LeaderboardList = (props) => {
    // console.log("LeaderboardList props:", props);
    const node = props.node;
    const customisationVars = props.node.customisationVars;
    const previewScale = props.previewScale || 1;

    // console.log('Leaderboardlist, customisationVars:', customisationVars);

    if (!customisationVars) {
        return null;
    }

    const setScoreBarSizeSettings = (mainBox = false) => {

        const boxSettings = customisationVars.visualHUD.visual.settings[0]
        const returnStyle =  {}

        // console.log('SCORE BOX SETTINGS: ', boxSettings)

        returnStyle['--containerPadding'] = boxSettings.boxPadding * previewScale + 'px';
        returnStyle['--containerBottomPadding'] = boxSettings.fixedHeight ? '0px' : boxSettings.boxPadding * previewScale + 'px';
        returnStyle['--containerHeight'] = boxSettings.fixedHeight ? boxSettings.boxHeight * previewScale + 'px' : '20%';
        returnStyle['--containerRadius'] = boxSettings.boxBorderRadius * previewScale + 'px';
        // if(boxSettings.addBox) returnStyle['--containerColour'] = boxSettings.boxBackgroundColour;
        returnStyle['--containerOpacity'] = boxSettings.boxOpacity/100;
        returnStyle['--borderThickness'] = boxSettings.addBorder ? boxSettings.borderThickness * previewScale + 'px' : '0px';

        if (mainBox && boxSettings.addBox) 
        {
            if(boxSettings.addBorder) returnStyle['border'] = 'solid '+ boxSettings.borderThickness * previewScale +'px '+boxSettings.borderColour;
            if(boxSettings.addShadow) returnStyle['box-shadow'] = boxSettings.shadowThickness * previewScale +'px '+boxSettings.shadowThickness * previewScale +'px '+ boxSettings.shadowBlur * previewScale +'px '+ boxSettings.shadowColour;
            
            if (boxSettings.imageBackground) {
                returnStyle.backgroundImage = 'url(' + boxSettings.filename.srcUrl + ')'
                returnStyle['backgroundSize'] = 'cover'
                returnStyle['backgroundRepeat'] = 'no-repeat'
                returnStyle['backgroundPosition'] = 'center center'
                returnStyle['opacity'] = boxSettings.boxOpacity / 100;
            }
            else {
                returnStyle['--containerColour'] = boxSettings.boxBackgroundColour;
                // returnStyle['opacity'] = boxSettings.boxOpacity / 100;
                returnStyle['--containerOpacity'] = boxSettings.boxOpacity / 100;
            }
        }


        returnStyle['--containerMaxHeight'] =  (1080  - (customisationVars.visualHUD.general.settings[0].edgeSpacing * previewScale * 2) -( boxSettings.boxPadding * previewScale * 2))+ 'px';
      
      
       const headerheight = document.getElementById('headerBar') ? document.getElementById('headerBar').getBoundingClientRect().height : 0;
                    
        returnStyle['--scoreBoardMaxHeight'] =  boxSettings.fixedHeight ? 
        (boxSettings.boxHeight - (boxSettings.boxPadding*2))+ 'px' : 
        (1080 - (boxSettings.boxPadding*2) - (customisationVars.visualHUD.general.settings[0].edgeSpacing * previewScale * 2) )- headerheight- boxSettings.titleSpacing * previewScale * 2 +'px' ;
       
        returnStyle['--boxHeight'] = boxSettings.scoreBoxHeight * previewScale + 'px';
        returnStyle['--boxWidthPad'] = boxSettings.scoreBoxWidth * previewScale + 'px'; // ( boxSettings.scoreBoxWidth - boxSettings.scoreBoxPadding * previewScale * 2)+ 'px';
        returnStyle['--boxWidth'] =  boxSettings.scoreBoxWidth * previewScale + 'px';
        returnStyle['--boxInnerWidth'] = (boxSettings.scoreBoxWidth - (10 * 2)) * previewScale + 'px';
        returnStyle['--boxHeightPad'] =  boxSettings.scoreBoxHeight * previewScale + 'px'; // boxSettings.scoreBoxPadding * 2 * previewScale + 'px';
        returnStyle['--boxPadding'] =  boxSettings.scoreBoxPadding * previewScale + 'px';
        returnStyle['--boxPaddingLeft'] =  boxSettings.scoreBoxPaddingLeft * previewScale + 'px';
        
        // returnStyle['--boxBorderThickness'] =  (boxSettings.addBox ? boxSettings.borderThickness : 0) * previewScale + 'px';
        returnStyle['--boxSpacing'] =  boxSettings.scoreBoxSpacing * previewScale + 'px';
        returnStyle['--boxLeftMargin'] =  0-(2*boxSettings.scoreBoxSpacing * previewScale) + 'px';
        returnStyle['--backgroundPadding'] =  customisationVars.visualHUD.general.settings[0].edgeSpacing * previewScale + 'px';

        returnStyle['--fullBoxWidth'] =  boxSettings.scoreBoxWidth * previewScale + 'px'; // (boxSettings.scoreBoxWidth + (boxSettings.scoreBoxPadding * 2)) * previewScale + 'px';
        returnStyle['--fullBoxHeight'] = boxSettings.scoreBoxHeight * previewScale + 'px'; // (boxSettings.scoreBoxHeight + (boxSettings.scoreBoxPadding * 2)) * previewScale + 'px';

        returnStyle['--smallScale'] =  boxSettings.smallScale/100;

        returnStyle['--titleBottomMargin'] = boxSettings.titleSpacing * previewScale + 'px';

        returnStyle['--listItemBgImage'] = customisationVars?.visualHUD?.visual?.scoreBoxImageSettings?.[0]?.filename?.srcUrl ? 'url(' + customisationVars.visualHUD.visual.scoreBoxImageSettings[0].filename.srcUrl + ')' : 'none';
        /*
        returnStyle['--listItemBgColour'] = customisationVars?.visualHUD?.visual?.scoreBoxSettings?.[0]?.backgroundColour || 'transparent';
        returnStyle['--listItemBorderColour'] = customisationVars?.visualHUD?.visual?.scoreBoxSettings?.[0]?.borderColour || 'transparent';
        returnStyle['--listItemBorderThickness'] = (customisationVars?.visualHUD?.visual?.scoreBoxSettings?.[0]?.borderThickness || 0) * previewScale + 'px';
        returnStyle['--listItemPositionBoxColour'] = customisationVars?.visualHUD?.visual?.scoreBoxSettings?.[0]?.positionBoxColour || 'transparent';
        */

        switch(customisationVars.visualHUD.general.settings[0].position)
        {
            case 'top-left':
                returnStyle['--transform-origin'] = 'left top';
                returnStyle['--transform-translate'] = 'translate(0, 0)';
            break;
            case 'top-center':
                returnStyle['--transform-origin'] = 'center top';
                returnStyle['--transform-translate'] = 'translate(50%, 0)';
            break;
            case 'top-right':
                returnStyle['--transform-origin'] = 'right top';
                returnStyle['--transform-translate'] = 'translate(0, 0)';
            break;
            case 'middle-left':
                returnStyle['--transform-origin'] = 'left center';
                returnStyle['--transform-translate'] = 'translate(0, -50%)';
            break;
            case 'middle-left':
                returnStyle['--transform-origin'] = 'left center';
                returnStyle['--transform-translate'] = ' translate(0, -50%)';
            break;
            case 'middle-center':
                returnStyle['--transform-origin'] = 'center center';
                returnStyle['--transform-translate'] = 'translate(50%, -50%)';
            break;
            case 'middle-right':
                returnStyle['--transform-origin'] = 'right center';
                returnStyle['--transform-translate'] = 'translate(0%, -50%)';
            break;
            case 'middle-right':
                returnStyle['--transform-origin'] = 'right center';
                returnStyle['--transform-translate'] = ' translate(0, -50%)';
            break;
            case 'bottom-left':
                returnStyle['--transform-origin'] = 'left bottom';
                returnStyle['--transform-translate'] = 'translate(0, 0)';
            break;
            case 'bottom-center':
                returnStyle['--transform-origin'] = 'center bottom';
                returnStyle['--transform-translate'] = 'translate(50%, 0)';
            break;
            case 'bottom-right':
                returnStyle['--transform-origin'] = 'right bottom';
                returnStyle['--transform-translate'] = 'translate(0, 0%)';
            break;
        }

        
        return returnStyle;

    }

    const getScoreBarColourStyleVars = (index) => {
        const boxSettings = customisationVars.visualHUD.visual.settings[0]

        const  returnStyle =  {}
        const dataIndex = index % customisationVars.visualHUD.visual.scoreBoxSettings.length;
        returnStyle['--listItemBgColour'] = customisationVars?.visualHUD?.visual?.scoreBoxSettings?.[dataIndex]?.backgroundColour || 'transparent';
        returnStyle['--listItemBorderColour'] = customisationVars?.visualHUD?.visual?.scoreBoxSettings?.[dataIndex]?.borderColour || 'transparent';
        returnStyle['--listItemBorderThickness'] = (customisationVars?.visualHUD?.visual?.scoreBoxSettings?.[dataIndex]?.borderThickness || 0) * previewScale + 'px';
        returnStyle['--listItemPositionBoxColour'] = customisationVars?.visualHUD?.visual?.scoreBoxSettings?.[dataIndex]?.positionBoxColour || 'transparent';
        returnStyle['--posBoxSizeH'] = (boxSettings.scoreBoxHeight - customisationVars?.visualHUD?.visual?.scoreBoxSettings?.[dataIndex]?.borderThickness * 2 - boxSettings.positionBoxMarginTopBottom) * previewScale + 'px';
        returnStyle['--posBoxSizeW'] = (boxSettings.scoreBoxHeight - customisationVars?.visualHUD?.visual?.scoreBoxSettings?.[dataIndex]?.borderThickness * 2 - boxSettings.positionBoxMarginLeftRight) * previewScale + 'px';
        returnStyle['--boxPaddingNeg'] =  (-boxSettings.scoreBoxPadding + boxSettings.positionBoxMarginLeftRight) * previewScale + 'px';
        returnStyle['--boxPosLeftPadding'] = boxSettings.positionBoxMarginLeftRight < 0 ? Math.abs(boxSettings.positionBoxMarginLeftRight) * previewScale + 'px' : '0px';

        return returnStyle;
    }

    const setBackgroundStyle = () =>{
        let returnStyle =  {}
        let backgroundSettings =  customisationVars.visualHUD.general.settings[0]
        if(backgroundSettings.useBackground)
        {
            if(backgroundSettings.imageBackground)
            {
                returnStyle.backgroundImage = 'url('+backgroundSettings.filename.srcUrl+')'
                returnStyle['backgroundSize'] = 'contain'
                returnStyle['backgroundRepeat'] = 'no-repeat'
                returnStyle['backgroundPosition'] =  'center center'
            }
            else
            {
                returnStyle['background-color'] = backgroundSettings.backgroundColour;
                returnStyle.opacity = backgroundSettings.backgroundOpacity / 100
            }
        }
        return returnStyle;
    }

    const getScoreBarShape = () =>{
        switch(customisationVars.visualHUD.visual.settings[0].scoreDisplayType)
        {
            case 0:
                return 'rect';
            break;
            case 1:
                return 'pill';
            break;
            case 2:
                return 'diag';
            break;
            case 3:
                return 'line-sep';
            break;
            case 4:
                return 'image-box';
            break;
            case 5:
                return 'transparent-box';
            break;
            default:
                return 'rect';
            break;
        }
    }

    const setScoreStyle = (fontSetting, scoreBoxSettings, setBGColour, setPositionColour, setBorder, setInnerColour,index, isTitle, isAchievement) => {


        const scoreDisplayType =  customisationVars.visualHUD.visual.settings[0].scoreDisplayType 
        let returnStyle =  {}
        if(fontSetting)
        {

            if(!isTitle || (isTitle && !fontSetting.useImage ))
            {
                //Sets the title image to use a font
                returnStyle.fontFamily =fontSetting.font
                returnStyle.color = fontSetting.fontColour
                returnStyle.fontSize = fontSetting.fontSize * previewScale +'px'
                
                if(fontSetting.showShadow)
                {
                returnStyle.textShadow = fontSetting.shadowThickness * previewScale +'px '+ fontSetting.shadowThickness * previewScale +'px '+ fontSetting.shadowBlur * previewScale +'px '+ fontSetting.shadowColour
                }

                //Is the font bold?
                if(fontSetting.isBold)returnStyle.fontWeight = 'bold'
            }
            else if(isTitle && fontSetting.useImage)
            {
                //Sets the title image to use an image
               /* returnStyle.backgroundImage = 'url('+fontSetting.filename.srcUrl+')'
                returnStyle['backgroundSize'] = 'contain'
                returnStyle['backgroundRepeat'] = 'no-repeat'
                returnStyle['backgroundPosition'] =  'center center'*/
          
            }
        }

        if(scoreBoxSettings)
        {
            let scoreBoxIndex = index % scoreBoxSettings.length
            let scoreImageIndex = index % + customisationVars.visualHUD.visual.scoreBoxImageSettings.length

            //Score box is not the line seperator type
            if(setBGColour) 
            {
                if(scoreDisplayType <= 1) returnStyle['background-color'] = scoreBoxSettings[scoreBoxIndex].backgroundColour;
                else if(scoreDisplayType == 2) 
                {
                    returnStyle['--bgColour'] = scoreBoxSettings[scoreBoxIndex].backgroundColour;
                    returnStyle['--diagScoreBackground'] = scoreBoxSettings[scoreBoxIndex].positionBoxColour;
                }
                else if(scoreDisplayType == 4) 
                {
                    returnStyle.backgroundImage = 'url('+customisationVars.visualHUD.visual.scoreBoxImageSettings[scoreImageIndex].filename.srcUrl+')'
                    returnStyle['backgroundSize'] = 'contain'
                    returnStyle['backgroundRepeat'] = 'no-repeat'
                    returnStyle['backgroundPosition'] =  'center center'
                }
            }
            if(setPositionColour && scoreDisplayType !=2 && scoreDisplayType != 4) returnStyle['background-color'] =  scoreBoxSettings[scoreBoxIndex].positionBoxColour;
           
            // console.log(scoreDisplayType)
            if(setBorder && scoreDisplayType != 4) 
            {
                returnStyle['--borderThickness'] = scoreBoxSettings[scoreBoxIndex].borderThickness * previewScale +'px';
               returnStyle['--diagBorder'] = 'solid '+ scoreBoxSettings[scoreBoxIndex].borderThickness * previewScale +'px '+ scoreBoxSettings[scoreBoxIndex].borderColour;
               
                if(scoreDisplayType <= 1) returnStyle.border = 'solid '+ scoreBoxSettings[scoreBoxIndex].borderThickness * previewScale +'px '+ scoreBoxSettings[scoreBoxIndex].borderColour;
                else if(scoreDisplayType == 3) 
                {
                    // console.log('SET BOTTOM BORDER')
                    returnStyle['border-bottom'] = 'solid '+ scoreBoxSettings[scoreBoxIndex].lineThickness * previewScale +'px '+ scoreBoxSettings[scoreBoxIndex].lineColour; 
                    //returnStyle['--diagBorder'] = 'solid '+ scoreBoxSettings[scoreBoxIndex].borderThickness+'px '+ scoreBoxSettings[scoreBoxIndex].borderColour;
                }
            
            }
        }
        return returnStyle;
    }

    const convertMSToHMS = (timeInMS, relativeTime = false, timeZoneAdjust = 0) => {
        // Adjust time in secs for timezone... timeInSecs is always utc or relative...
        if (!relativeTime) {
            const timeZoneAdjustMs = timeZoneAdjust * 3600 * 1000;
            timeInMS += timeZoneAdjustMs;
        }
    
        let h = 0, m = 0, s = 0, hun = 0;
        if (timeInMS >= 0) {
            h = Math.floor(timeInMS / 1000 / 3600);
            m = Math.floor((timeInMS / 1000 - h * 3600) / 60);
            s = (timeInMS / 1000 - h * 3600 - m * 60);
            hun = timeInMS-(Math.floor(timeInMS/1000)*1000);
        }
    
        // For relative times, don't clamp the hours!
        if (!relativeTime) {
            while (h < 0) h += 24;
            while (h > 23) h -= 24;
        }
    
        return {
            h: h, h_str: h >= 10 ? Math.floor(h) : '0' + Math.floor(h), 
            m: m, m_str: m >= 10 ? Math.floor(m) : '0' + Math.floor(m), 
            s: s, s_str: s >= 10 ? Math.floor(s) : '0' + Math.floor(s),
            hun: hun, hun_str: hun >= 100 ? hun : hun >=10 ? '0'+hun : '00'+hun}
    }

    const getScoreCopy = (scoreData) => {

        let score = scoreData?.score ?? 0;
        let leaderboardSetup = customisationVars.leaderboard.settings.setup[0];
        switch( customisationVars.leaderboard.settings.setup[0].scoreType)
        {
            //### TIME BASED SCORE COPY
            case 'time': 
                //Overide the score to be the time and returns the score vlaue in the necessary time string
                score = scoreData?.time * 1000 ?? 0;
                if(score !=0 || !scoreData.showCopyZeroScore)
                {
                    //Set the time strings based on the score value
                    let timeStrings = convertMSToHMS(score);
                    let totalMins = (timeStrings.h*60)+timeStrings.m;
                    let minsStr = totalMins >= 10 ? Math.floor(totalMins) : '0' + Math.floor(totalMins)
                    let totalSecs = (totalMins*60)+timeStrings.s;
                    let secStr = totalSecs >= 10 ? Math.floor(totalSecs) : '0' + Math.floor(totalSecs)
            
                    //Replace the score value with the relevent time string set out in the ICAST customisation settings
                    switch(customisationVars.leaderboard.settings.setup[0].timeDisplay)
                    {
                        case 'hms':
                            score = timeStrings.h+':'+timeStrings.m_str+':'+timeStrings.s_str
                        break;
                        case 'ms':
                            score = minsStr+':'+timeStrings.s_str
                        break;
                        case 'hm':
                            score = timeStrings.h+':'+timeStrings.m_str
                        break;
                        case 's':
                            score = secStr +'s'
                        break;
                    }
                }
                else if(scoreData.showCopyZeroScore && (!scoreData.time || scoreData.time == undefined || scoreData.time == 0)) 
                {
                    //Replace a zero time with the custom copy setup in the ICAST customisations (If required)
                    score = scoreData.copy;
                }
            break;

            //### DISTANCE BASED SCORE COPY
            case 'distance':
                //Returns the score with the necessary distance measuremnet added to the end of the vlaue (eg 10m, 20 Kills etc) 
                if((score !=0 || !scoreData.showCopyZeroScore) &&  leaderboardSetup.type == 'leaderboard')
                {
                    score += leaderboardSetup.distanceText;  
                } 
                if(scoreData.score == 0 && scoreData.showCopyZeroScore) 
                {
                     //Replace a zero score with the custom copy setup in the ICAST customisations (If required)
                    score = scoreData.copy;
                }
            break;

            //## ALL OTHER SCORE COPY
            default:
                if((!scoreData.score || scoreData.score == 0 || scoreData.score == undefined) && scoreData.showCopyZeroScore) 
                {
                    //Replace a zero score with the custom copy setup in the ICAST customisations (If required)
                    score = scoreData.copy;
                }
            break;
        }
        return score;
    }

    const getTextShadowSetting = (rawSettings) => {
        if(rawSettings.showShadow)
        {
            return {textShadow: rawSettings.shadowThickness * previewScale +'px '+ rawSettings.shadowThickness * previewScale +'px '+ rawSettings.shadowBlur * previewScale +'px '+ rawSettings.shadowColour}
        }
        return {};
    }

    const listItemNode = findSubNode(props.node?.topNode ?? props.node, 'List Item');
    listItemNode.dontVisualiseModuleSettings = {
        dimensions: true,
    }

    const positionBoxTranslateStyle = {
        transform: `translate(${getCustomisationValue(customisationVars, 'visualHUD.textSettings.posTextSettings.xOffset', 0, props.customVisualisedNodeKey, node) * previewScale}px, ${getCustomisationValue(customisationVars, 'visualHUD.textSettings.posTextSettings.yOffset', 0, props.customVisualisedNodeKey, node) * previewScale}px)`,
    }
    const nameTranslateStyle = {
        transform: `translate(${getCustomisationValue(customisationVars, 'visualHUD.textSettings.nameTextSettings.xOffset', 0, props.customVisualisedNodeKey, node) * previewScale}px, ${getCustomisationValue(customisationVars, 'visualHUD.textSettings.nameTextSettings.yOffset', 0, props.customVisualisedNodeKey, node) * previewScale}px)`,
    }
    const scoreTranslateStyle = {
        transform: `translate(${getCustomisationValue(customisationVars, 'visualHUD.textSettings.scoreTextSettings.xOffset', 0, props.customVisualisedNodeKey, node) * previewScale}px, ${getCustomisationValue(customisationVars, 'visualHUD.textSettings.scoreTextSettings.yOffset', 0, props.customVisualisedNodeKey, node) * previewScale}px)`,
    }
    const playerImagePositionStyle = {
        position: 'absolute',
        left: getCustomisationValue(customisationVars, 'visualHUD.visual.settings.playerImageXOffset', 0, props.customVisualisedNodeKey, node) * previewScale + 'px',
        top: getCustomisationValue(customisationVars, 'visualHUD.visual.settings.playerImageYOffset', 0, props.customVisualisedNodeKey, node) * previewScale + 'px',
        // maxHeight: getCustomisationValue(customisationVars, 'visualHUD.visual.settings.scoreBoxHeight', 50, props.customVisualisedNodeKey, node) * previewScale + 'px',
    }

    const scoresToDisplay = [];
    const rawScoresData = getGroupData(customisationVars, 'leaderboard.leaderboardData.entries', -1, true) || [];
    // console.log('rawScoresData:', rawScoresData);
    for (let i = 0; i < 20; i++) {
        if (i < rawScoresData.length) {
            scoresToDisplay.push({...rawScoresData[i], dataIndex: i, realData: true});
        } /* else {
            if (i < DUMMY_LEADERBOARD_DATA.length) {
                scoresToDisplay.push({ rank: i + 1, name: `Player ${i + 1}`, score: DUMMY_LEADERBOARD_DATA[i].score, time: DUMMY_LEADERBOARD_DATA[i].time, copy: 'No Score', showCopyZeroScore: true, addPlayerImage: true, playerImage: {srcUrl: PlayerImagePlaceholder} });
            } else {
                break;
            }
        } */
    }
    const sortAscending = customisationVars.leaderboard.settings.setup[0].ascending;
    scoresToDisplay.sort((a, b) => {
        let valA, valB;
        switch (customisationVars.leaderboard.settings.setup[0].scoreType) {
            case 'time':
                valA = a.time || 0;
                valB = b.time || 0;
                break;
            case 'distance':
            case 'points':
            default:
                valA = a.score || 0;
                valB = b.score || 0;
                break;
        }
        return sortAscending ? valA - valB : valB - valA;
    });

    let listItems = scoresToDisplay.map((score, index) =>
        <div className="v2-vis-ed__score-box-centered-container" style={getScoreBarColourStyleVars(index)} key={index}>
        <VisualisedNode
            {...props}
            node={listItemNode}
        >
            <div className={`v2-vis-ed__score-bar-holder ${getScoreBarShape()}`}>
                <div className="v2-vis-ed__score-bar-bg"></div>
                
                <div className="v2-vis-ed__score-bar-content">

                    {score.addPlayerImage && score.playerImage && score.playerImage.srcUrl &&
                        <VisualisedNode
                            {...props}
                            node={findSubNode(props.node?.topNode ?? props.node, 'Player Image')}
                            dontVisualiseModuleSettings={{
                                position: true,
                            }}
                            style={playerImagePositionStyle}
                        >
                            {score.playerImage.srcUrl === PlayerImagePlaceholder &&
                                <img src={PlayerImagePlaceholder} alt="Player" style={{maxHeight: getCustomisationValue(customisationVars, 'visualHUD.visual.settings.scoreBoxHeight', 50, props.customVisualisedNodeKey, node) * previewScale + 'px'}} />
                            }
                            {score.playerImage.srcUrl !== PlayerImagePlaceholder &&
                                <VisualisedNode
                                    {...props}
                                    textEditModeContentNode={findSubNode(props.node?.topNode ?? props.node, 'Leaderboard Data')}

                                    textEditMode={true}
                                    selectOnly={true}
                                    index={score.dataIndex ?? 0}
                                    textEditModeFieldPath="leaderboard.leaderboardData.entries.playerImage"
                                    content={<img src={score.playerImage.srcUrl} alt="Player" />}
                                />
                            }
                        </VisualisedNode>
                    }

                    {customisationVars.visualHUD.visual.settings[0].showPositionBox &&
                        <VisualisedNode
                            {...props}
                            node={findSubNode(props.node?.topNode ?? props.node, 'Position Box')}
                            dontVisualiseModuleSettings={{
                                position: true,
                            }}
                            style={{...positionBoxTranslateStyle, ...getScoreBarColourStyleVars(index), ...setScoreBarSizeSettings()}}
                        >
                            <div className={`${getScoreBarShape()} v2-vis-ed__pos`} style={getTextShadowSetting(customisationVars.visualHUD.textSettings.posTextSettings[0])}>
                                <div className="v2-vis-ed__pos-content">
                                    {index + 1}
                                </div>
                            </div>
                        </VisualisedNode>
                    }
                    <div className="v2-vis-ed__name" style={getTextShadowSetting(customisationVars.visualHUD.textSettings.nameTextSettings[0])}>
                        <VisualisedNode
                            {...props}
                            node={findSubNode(props.node?.topNode ?? props.node, 'Name Display')}
                            dontVisualiseModuleSettings={{
                                position: true,
                            }}
                            style={nameTranslateStyle}
                        >
                            {!score.realData && <>{score.overrideName && score.overrideName !== '' && score.overrideName.trim() !== '' ? score.overrideName : score.name}</>}
                            {score.realData && 
                                <VisualisedNode
                                    {...props}
                                    textEditModeContentNode={findSubNode(props.node?.topNode ?? props.node, 'Leaderboard Data')}
                                    textEditMode={true}
                                    index={score.dataIndex ?? 0}
                                    textEditModeFieldPath={"leaderboard.leaderboardData.entries." + (score.overrideName && score.overrideName !== '' ? 'overrideName' : 'name')}
                                    content={(score.overrideName && score.overrideName !== '' && score.overrideName.trim() !== '') ? score.overrideName : score.name}
                                />
                            }
                        </VisualisedNode>
                    </div>
                    <div className="grow"></div>
                    <div className="v2-vis-ed__score" style={getTextShadowSetting(customisationVars.visualHUD.textSettings.scoreTextSettings[0])}>
                        <VisualisedNode
                            {...props}
                            node={findSubNode(props.node?.topNode ?? props.node, 'Score Display')}
                            dontVisualiseModuleSettings={{
                                position: true,
                            }}
                            style={scoreTranslateStyle}
                        >
                            {!score.realData && <>{getScoreCopy(score)}</>}
                            {score.realData && 
                                <VisualisedNode
                                    {...props}
                                    textEditModeContentNode={findSubNode(props.node?.topNode ?? props.node, 'Leaderboard Data')}

                                    textEditMode={true}
                                    selectOnly={getScoreCopy(score) !== score.copy}
                                    index={score.dataIndex ?? 0}
                                    textEditModeFieldPath="leaderboard.leaderboardData.entries.copy"
                                    content={getScoreCopy(score)}
                                />
                            }
                        </VisualisedNode>
                    </div>
                </div>
            </div>
            {/*((customisationVars.leaderboard.settings.setup[0].type == 'leaderboard' && !useForcedData) ||
               (customisationVars.leaderboard.settings.setup[0].type == 'compChallenge') ||
               (customisationVars.leaderboard.settings.setup[0].type == 'spam' && index < customisationVars.leaderboard.settings.setup[0].numberOfSpamScores) ||
                (customisationVars.leaderboard.settings.setup[0].type == 'leaderboard' && useForcedData && index < listLimit)) && */}
            {/* <div className={'scoreBar ' + getScoreBarShape()}
                style={{
                        ...setScoreStyle(
                            null,
                            customisationVars.visualHUD.visual.scoreBoxSettings,
                            true, false, true, false, index
                        ),
                        flexDirection: 'row',
                    }}
                // ref={createScoreRef(index)}
                key={index}
            >
                {customisationVars.visualHUD.visual.settings[0].showPositionBox &&
                    <VisualisedNode
                        {...props}
                        node={findSubNode(props.node?.topNode ?? props.node, 'Position Box')}
                    >
                        <div className='positionBox' style={
                            setScoreStyle(
                                customisationVars.visualHUD.textSettings.posTextSettings[0],
                                customisationVars.visualHUD.visual.scoreBoxSettings,
                                false, true, false, false, index
                            )}>{index + 1}
                        </div>
                    </VisualisedNode>
                }
                
                    <div className='playerName' style={
                        setScoreStyle(
                            customisationVars.visualHUD.textSettings.nameTextSettings[0],
                            null,
                        )}
                    >
                            <VisualisedNode
                                {...props}
                                node={findSubNode(props.node?.topNode ?? props.node, 'Name Display')}
                            >
                                {score.overrideName && score.overrideName !== '' ? score.overrideName : score.name}
                            </VisualisedNode>
                    </div>
                
                
                    <div className='score' style={
                        setScoreStyle(
                            customisationVars.visualHUD.textSettings.scoreTextSettings[0],
                            null,
                        )}
                    >
                            <VisualisedNode
                                {...props}
                                node={findSubNode(props.node?.topNode ?? props.node, 'Score Display')}
                            >
                                {getScoreCopy(score)}
                            </VisualisedNode>
                    </div>
                
            </div> */}

        </VisualisedNode>
        </div>
    );

    return (
        <>
            <div style={{height: getCustomisationValue(customisationVars, 'visualHUD.visual.settings.titleSpacing', 0, props.customVisualisedNodeKey, node) * previewScale + 'px'}}></div>
            <div className={`leaderboard-list ${getScoreBarShape()}`} style={{...setScoreBarSizeSettings(), gap: getCustomisationValue(customisationVars, 'visualHUD.visual.settings.scoreBoxSpacing', 0, props.customVisualisedNodeKey, node) * previewScale + 'px' || '8px', marginTop: 10 * previewScale + 'px', marginBottom: 10 * previewScale + 'px'}}>
                { listItems }
            </div>
        </>
    )
}

export default LeaderboardList;
